export const BarkType = {
  Birch: 'birch',
  Oak: 'oak',
  Pine: 'pine',
  Willow: 'willow'
};

export const Billboard = {
  Single: 'single',
  Double: 'double',
};

export const LeafType = {
  Ash: 'ash',
  Aspen: 'aspen',
  Pine: 'pine',
  Oak: 'oak',
};

export const TreeType = {
  Deciduous: 'deciduous',
  Evergreen: 'evergreen',
};